<template>
  <div class="comp-bg">
    <div id="carouselExampleIndicators" class="carousel splash" data-ride="carousel">
      <ol class="carousel-indicators">
        <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
      </ol>
      <div class="carousel-inner">
        <div class="carousel-item splash active">
          <img src="/static/banner-competition.jpg" class="d-block w-100" alt="..." />
        </div>
        <div class="carousel-item splash">
          <img src="/static/banner-competition.jpg" class="d-block w-100" alt="..." />
        </div>
        <div class="carousel-item splash">
          <img src="/static/banner-competition.jpg" class="d-block w-100" alt="..." />
        </div>
      </div>
      <a
        class="carousel-control-prev"
        href="#carouselExampleIndicators"
        role="button"
        data-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a
        class="carousel-control-next"
        href="#carouselExampleIndicators"
        role="button"
        data-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>

    <div id="nav-1" class="nav-1 container-fluid">
      <nav class="navbar navbar-light justify-content-center">
        <!-- <a class="navbar-brand" href="#">Navbar</a> -->
        <ul class="nav row justify-content-center">
          <li class="nav-item col-5 col-sm-3">
            <a class="nav-link" href="#synopsis">
              <img class="img-fluid" src="/static/navbar-0.png" />
            </a>
          </li>
          <li class="nav-item col-5 col-sm-3">
            <a class="nav-link" href="#detail">
              <img class="img-fluid" src="/static/navbar-1.png" />
            </a>
          </li>
          <li class="nav-item col-5 col-sm-3">
            <a class="nav-link" href="#signup">
              <img class="img-fluid" src="/static/navbar-2.png" />
            </a>
          </li>
          <li class="nav-item col-5 col-sm-3">
            <a class="nav-link" href="#share">
              <img class="img-fluid" src="/static/navbar-3.png" />
            </a>
          </li>
          <!-- <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">Dropdown</a>
            <div class="dropdown-menu">
              <a class="dropdown-item" href="#one">one</a>
              <a class="dropdown-item" href="#two">two</a>
              <div role="separator" class="dropdown-divider"></div>
              <a class="dropdown-item" href="#three">three</a>
            </div>
          </li>-->
        </ul>
      </nav>
    </div>
    <div class="container-sm">
      <div id="synopsis">
        <img src="/static/navbar-0-01.png" class="w-100" />

           <div style=" position: relative;" class="w-100">
          <img src="/static/navbar-0-04.png" class="w-100" style="display:block;" />
          <P class="zpyq" style="top: 53%;left: 14%;margin-right:10% ">&#12288;&#12288;以传承红色文化为主题展开3D模型设计，充分发挥自主想象力和创造力，体现红色精神和红色文化。<h style="color:rgb(201,99,56)">设计关键词：爱国、敬党、传承、创新、与时俱进。</h></p>
          <p class="zpyq" style="top: 70%;left: 14%;margin-right:10% ">&#12288;&#12288;以传承红色文化为背景，开展6期线上红色文化的3D模型课程。每期课程参赛者需线上签到打卡并根据每期的主题设计相应的3D模型。</p>
            
          <p class="zpyq" style="top: 78%;left: 14%;margin-right:10% ">----------------------------------------------</p>
            <p class="zpyq" style="top: 81%;left: 14%;margin-right:10% ">&#12288;&#12288;参赛的所有作品必须是原创，集体创作作品参赛需征得主创人员的同意。获奖作品将通过网络媒体公示
。严禁抄袭、摹仿、拷贝他人的作品，一经查出，大赛组委会有权取消其参赛资格，若为获奖作品，则追回颁发奖励并进行公告。</p>

    </div>
                <!-- <div style=" position: relative;" class="w-100">
          <img src="/static/navbar-0-01.png" class="w-100" style="display:block;" />
          <P class="dsbj" style="top: 10%;left: 12%;margin-right:10% ">&#12288;&#12288;为庆祝建党100周年，清软海芯联合清华大学软件学院计算机辅助设计图形学与可视化研究所协同举办2021年全国青少年LogoUp 3D创意设计大赛，以“红色传承，创意赋能”为主题，号召青少年学生群体深入学习经典红色故事、优秀的革命英雄及事迹等，以3D设计红色元素模型作为作业，唤醒学生们内心的爱国情怀，学习传承深厚的革命文化底蕴。</p>
          <p class="csxs" style="top: 74%;left: 15%;margin-right:15% ;color:black"> &#12288;&#12288;两个组的培训课程内容、比赛形式与规则均有不同（详见比赛细则）。梦想进阶组适合无编程设计基础的学生报名，参赛没较低，并且有年龄限制；而创新决胜组强调竞技，适合有一定编程设计基础，
创作力较高的学生，按年龄分为小学（一至六年级）和中学组（初中至高中阶段），学生可根据自身情况报名。
            
</p>
    </div> -->
        <!-- <img src="/static/navbar-0-02.png" class="w-100" /> -->
          <div style=" position: relative;" class="w-100">
          <img src="/static/navbar-0-02.png" class="w-100" style="display:block;" />
          <P class="jpjl" style="top: 59%;left: 21%;margin-right:8% ">
            <h style="color:rgb(111, 150, 222)">创新决胜组(小学/中学组)、梦想进阶组</h><br/>
            <h style="color:rgb(111, 150, 222)">一等奖(1名)</h> 奖学金人民币<h style="color:rgb(207, 102, 57)">2000</h>元及价值1000元奖品<br/>
            <h style="color:rgb(111, 150, 222)">二等奖(3名)</h> 奖学金人民币<h style="color:rgb(207, 102, 57)">800</h>元及价值1000元奖品<br/>
            <h style="color:rgb(111, 150, 222)"> 三等奖(5名)</h> 奖学金人民币<h style="color:rgb(207, 102, 57)">300</h>元及价值1000元奖品<br/>
            <!-- <h style="color:rgb(111, 150, 222)">优秀奖</h>（参与人数5%） -->
          </p>
          <p class="jpjl" style="top: 85%;left: 21%;margin-right:8% "> 奖学金人民币<h style="color:rgb(207, 102, 57)">1000</h>元及价值1000元奖品</p>
          <p class="jpjl" style="top: 91%;left: 21%;margin-right:8% "> *以上凡是参赛选手、组织者均颁发奖状证书</p>


    </div>
        <!-- <img src="/static/navbar-0-03.png" class="w-100" /> -->

        <div style=" position: relative;" class="w-100">
          <img src="/static/navbar-0-03.png" class="w-100" style="display:block;" />
          <P class="zptj" style="top: 13%;left: 13%;margin-right:9% ">&#12288;&#12288;比赛作品统一报送至大赛组委会邮箱：<a style="color:rgb(201,99,56)" href="mailto:cooperation@hesion3d.com">cooperation@hesion3d.com</a>，作品由组委会工作人员统一审核筛选并上传至清软海芯科技的官网。</p>
          <p class="zptj" style="top: 34%;left: 13%;margin-right:9% "> 
&#12288;&#12288;1、递交文件命名格式：组别+所在市+学校名+参赛学生（例：创新决胜组(小学/中学组)+云浮市+郁南实验中学+王小明）；<br/>
&#12288;&#12288;2、提交文件内容：作品说明文档(参考附件一)+作品源文件（文件格式为logoup或stl等）；<br/>
&#12288;&#12288;3、（可选）设计参赛模型亦可进行实体搭建和零件装配，并制作相关功能演示动画或视频。如进行实体搭建后，提交作品内容如下：<br/>
&#12288;&#12288;①、提交文件包括：设计说明文档（WORD 文档），源文件，演示动画（建议格式为：MP4）和作品缩略图。<br/>
&#12288;&#12288;②、作品（含设计说明文档、源文件、演示动画、作品缩略图）大小建议不超过 100MB。
</p>
 <p class="zptj" style="top: 87%;left: 10%;margin-right:8% ">
<h style="color:rgb(111, 150, 222)">主办单位</h> &#12288;北京清软海芯科技有限公司 <br>
<h style="color:rgb(111, 150, 222)">协办单位</h> &#12288;清华大学软件学院计算机辅助设计图形学与可视化研究所<br>
<h style="color:rgb(111, 150, 222)">参赛平台</h> &#12288;LogoUp 3D官网、LogoUp 3D学习平台<br>

    </p>
    </div>
        <!-- <img src="/static/navbar-0-04.png" class="w-100" /> -->
            
        <!-- <img src="/static/navbar-0-05.png" class="w-100" /> -->

           <div style=" position: relative;" class="w-100">
          <img src="/static/navbar-0-05.png" class="w-100" style="display:block;" />
          <P class="bqsm" style="top: 14%;left: 14%;margin-right:8% ">
            （一）每位报名者应是其参赛作品的作者或者合法的版权所有者。<br>
            （二）集体创作作品，报名者必须保证对作品有合法的版权，或以所有作者的名义参赛。<br>
            （三）作者拥有作品的全部版权，获奖作品由组委会联系相关机构进行产业转化，所得收益，另行签署协议。<br>
         </p>
          <p class="bqsm" style="top: 50%;left: 14%;margin-right:8%; ">  
             
          &#12288;&#12288;*本届大赛各项活动的最终解释权归大赛举办方北京清软海芯科技有限公司所有<br/>
 
         </p>
         <p class="bqsm" style="top: 68%;left: 14%;margin-right:8% "> 
           大赛组委会秘书处<br>
          地址：北京市海淀区上地信息路11号彩虹大厦北楼西401<br>
         电话：<a href="tel:010-62966651" style="color:rgb(201,99,56)" >010-62966651</a><br>
        邮箱：<a style="color:rgb(201,99,56)" href="mailto:cooperation@hesion3d.com">cooperation@hesion3d.com</a><br>

         </p>
    </div>
      </div>
      <div id="detail">
        <!-- <img src="/static/navbar-1-01.png" class="w-100" /> -->

    <div style=" position: relative;" class="w-100 bsxz">
          <img src="/static/navbar-1-01.png" class="w-100" style="display:block;" />
          <P class="bsxz" style="top: 20%;left: 13%;margin-right:9% ">&#12288;&#12288;即比赛时间4月6日起，举办方每隔14天会在官网发布比赛的项目主题，共计3个主题，参赛者即可根据主题进行模型设计。</p>
          <p class="bsxz" style="top: 47%;left: 13%;margin-right:9% ">&#12288;&#12288;即比赛时间4月9日起，举办方会每周在LogoUp3D学习平台上开展红色文化3D模型课程，参赛成员需准时打卡进班学习，并完成本节课布置的主题模型。</p>
    </div>

        <a href="https://appxd0aquww5168.h5.xiaoeknow.com" target="_Blank">
          <img src="/static/navbar-1-02.png" class="w-100" />
        </a>
        <!-- <img src="/static/navbar-1-03.png" class="w-100" /> -->
        <div style="margin:7.6%;">
          <div class="table-top">创新决胜组</div>
          <table
            class="w-100"
            style="vertical-align: middle;border:3px solid rgb(87,120,187);background: rgb(10,29,78);"
            border="1px"
          >
            <tr >
              <td  class="table-header" style="width:33%">日期</td>
              <td class="table-header">日程内容</td>
              <td class="table-header">地点</td>
            </tr>

            <tr>
              <td class="table-td">4月9日</td>
              <td class="table-td">软件介绍及赛事答疑</td>
              <td rowspan="5"  class="table-td" style="font-size:1vm;text-align:center">
                 线上LogoUp3D官网
                <br />http://logoup3d.com/
                
              </td>
            </tr>
            <tr class="table-td">
              <td class="table-td">4月6日-4月20日</td>
              <td class="table-td"><router-link class="nav-link" to='/subject1?subject=1'>（第1轮）、红色记忆</router-link></td>
            </tr>
            <tr class="table-td">
              <td class="table-td">4月21日-5月5日</td>
              <td class="table-td"><router-link class="nav-link" to='/subject1?subject=2'>（第2轮）、党旗飘飘</router-link></td>
            </tr>
            <tr class="table-td">
              <td class="table-td">5月6日-5月20日</td>
              <td class="table-td"><router-link class="nav-link" to='/subject1?subject=3'>（第3轮）、红色烙印</router-link></td>
            </tr>
            <tr class="table-td">
              <td class="table-td">6月25日</td>
              <td class="table-td">赛事总结及公布比赛成绩</td>
            </tr>
          </table>
          <div> <p class="table-detail">注：作品提交的截止日期均为每轮比赛的截止日期，例如：第一轮比赛作品提交的截止日期为4月20日下午六点前，以此类推。</p></div>
          <div class="table-top">梦想进阶组</div>
          <table
            class="w-100"
            style="border:3px solid rgb(87,120,187);background: rgb(10,29,78);"
            border="1px"
          >
            <tr >
              <td class="table-header" style="width:33%">日期</td>
              <td class="table-header">日程内容</td>
              <td class="table-header">地点</td>
            </tr>
            <tr style="color:white;">
              <td class="table-td">4月9日</td>
              <td class="table-td">软件介绍及赛事答疑</td>
              <td rowspan="9" class="table-td" style="text-align:center">
                 
                <a href="https://appxd0aquww5168.h5.xiaoeknow.com" style="color:rgb(111, 150, 222);text-decoration:underline;" >LogoUp 3D学习平台</a>
              </td>
            </tr>
            <tr style="color:white;font-size:1vm;">
              <td class="table-td">4月17日-4月23日</td>
              <td class="table-td" style="text-align: left;" >1、中国共产党的成立</td>
            </tr>
            <tr style="color:white;font-size:1vm;">
              <td class="table-td">4月24日-4月30日</td>
              <td class="table-td" style="text-align: left;">2、清华大学的历史故事</td>
            </tr>
            <tr style="color:white;font-size:1vm;">
              <td class="table-td">5月8日-5月14日</td>
              <td class="table-td" style="text-align: left;">3、新中国的成立</td>
            </tr>
            <tr style="color:white;font-size:1vm;">
              <td class="table-td">5月15日-5月21日</td>
              <td class="table-td" style="text-align: left;" >4、改革开放</td>
            </tr>

            <tr style="color:white;font-size:1vm;">
              <td class="table-td">5月22日-5月28日</td>
              <td class="table-td" style="text-align: left;" >5、科技强国</td>
            </tr>
            <tr style="color:white;font-size:1vm;">
              <td class="table-td">5月29日-6月6日</td>
              <td class="table-td" style="text-align: left;">6、教育先锋</td>
            </tr>
            <tr style="color:white;font-size:1vm;">
              <td class="table-td">6月7日-6月14日</td>
              <td class="table-td" style="text-align: left;">7、拉票环节</td>
            </tr>
            <tr style="color:white;font-size:1vm;">
              <td class="table-td">6月25日</td>
              <td class="table-td" style="text-align: left;">赛事总结及公布比赛成绩</td>
            </tr>
          </table>
          <div>
            <div 
           
            > <p class="table-detail">注：作品提交的截止日期均为每轮比赛的截止日期，例如：第一轮比赛作品提交的截止日期为4月23日下午六点前，以此类推。</p></div>
          </div>
        </div>
        <!-- <img src="/static/navbar-1-04.png" class="w-100" /> <h style="color:rgb(111, 150, 222)">-->
         <div style=" position: relative;" class="w-100">
          <img src="/static/navbar-1-04.png" class="w-100" style="display:block;" />
          <P class="jfgz" style="top: 20%;left: 14%;margin-right:9% ">&#12288;&#12288;总计三个作品，每个作品都会进行评审和打分，并计入总分。最终根据总分进行先后排名。</p>
          <p class="jfgz" style="top: 45.5%;left: 19%;margin-right:9%;color:rgb(111, 150, 222) "> 打卡签到</p>
          <p class="jfgz" style="top: 49.5%;left: 19%;margin-right:9% "> 每次签到打卡计分5分，共六次总分30分，记录总分。</p>
          <p class="jfgz" style="top: 56%;left: 19%;margin-right:9% ;color:rgb(111, 150, 222)"> 作品评审</p>
          <p class="jfgz" style="top: 60%;left: 19%;margin-right:9%; "> 作品依次进行评审打分，每个作品满分10分总共60分，6个作品分数进行累加，记录总分。</p>
          <p class="jfgz" style="top: 72%;left: 19%;margin-right:9%;color:rgb(111, 150, 222) "> 拉票环节计分</p>
          <p class="jfgz" style="top: 76%;left: 19%;margin-right:9% "> 拉票环节为期7天，七天进行拉票点赞：</p>
          <p class="jfgz" style="top: 82.9%;left: 19%;margin-right:9%;color:rgb(111, 150, 222) "> 累计总成绩</p>
       
    </div>
        <img src="/static/navbar-1-05.png" class="w-100" />
      </div>
      <div id="signup">
        <img src="/static/navbar-2-01.png" class="w-100" />
        <a href="/static/competition.zip" target="_blank">
          <img src="/static/navbar-2-02.png" class="w-100" />
        </a>
        <a href="https://wj.qq.com/s2/8180302/bcc0" target="_Blank">
          <img src="/static/navbar-2-03.png" class="w-100" />
        </a>
        <!-- <img src="/static/navbar-2-04.png" class="w-100" /> -->
        <div style=" position: relative;" class="w-100 ">
          <img src="/static/navbar-2-04.png" class="w-100" style="display:block;" />
          <P class="sysm" style="top: 8%;left: 31%;margin-right:9%;color:rgb(111, 150, 222) ">比赛期间LogoUp软件使用说明</p>
          <p class="sysm" style="top: 18.5%;left: 17%;margin-right:9%; "> 未使用过LogoUp软件的学生可以在清软海芯官网上下载<br>LogoUp 3D免费试用版本（150行代码，试用期3个月）。</p>
          <p class="sysm" style="top: 34.2%;left: 17%;margin-right:9% "> 已经下载使用过教育体验版的学生，建议购买价格200元的LogoUp软件比赛套餐（无权限限制+7节免费在线课程），有效期3个月。</p>
    </div>
      </div>
    </div>
    <!-- <img id="synopsis" src="/static/comp-content-1.png" class="w-100">
    <img id="fate" src="/static/comp-content-1.png" class="w-100">
    <img id="mdo" src="/static/comp-content-1.png" class="w-100">
    <img id="fo" src="/static/comp-content-1.png" class="w-100">
    <a class="btn btn-primary" href="https://wj.qq.com/s2/8180302/bcc0 "  target="_Blank">比赛报名</a>-->
    <!-- <iframe height="1200" width="800" src="https://wj.qq.com/s2/8180302/bcc0" frameborder="0" allowfullscreen></iframe> -->
    <!-- <div data-spy="scroll" data-target="#nav-1" data-offset="0">
        <h4 id="fate">@fat</h4>
        <p>Placeholder content for the scrollspy example. You got the finest architecture. Passport stamps, she's cosmopolitan. Fine, fresh, fierce, we got it on lock. Never planned that one day I'd be losing you. She eats your heart out. Your kiss is cosmic, every move is magic. I mean the ones, I mean like she's the one. Greetings loved ones let's take a journey. Just own the night like the 4th of July! But you'd rather get wasted.</p>
        <h4 id="mdo">@mdo</h4>
        <p>Placeholder content for the scrollspy example. You got the finest architecture. Passport stamps, she's cosmopolitan. Fine, fresh, fierce, we got it on lock. Never planned that one day I'd be losing you. She eats your heart out. Your kiss is cosmic, every move is magic. I mean the ones, I mean like she's the one. Greetings loved ones let's take a journey. Just own the night like the 4th of July! But you'd rather get wasted.Placeholder content for the scrollspy example. You got the finest architecture. Passport stamps, she's cosmopolitan. Fine, fresh, fierce, we got it on lock. Never planned that one day I'd be losing you. She eats your heart out. Your kiss is cosmic, every move is magic. I mean the ones, I mean like she's the one. Greetings loved ones let's take a journey. Just own the night like the 4th of July! But you'd rather get wasted.Placeholder content for the scrollspy example. You got the finest architecture. Passport stamps, she's cosmopolitan. Fine, fresh, fierce, we got it on lock. Never planned that one day I'd be losing you. She eats your heart out. Your kiss is cosmic, every move is magic. I mean the ones, I mean like she's the one. Greetings loved ones let's take a journey. Just own the night like the 4th of July! But you'd rather get wasted.</p>
        <h4 id="one">one</h4>
        <p>...</p>
        <h4 id="two">two</h4>
        <p>...</p>
        <h4 id="three">three</h4>
        <p>...</p>
    </div>-->
    <!-- <div class="container">
      <div class="col-lg-12 col-xl-12" style="background-color:#000">1122</div>

    </div>-->
    <!-- <div class="jumbotron jumbotron-fluid splash">
      <div class="container-fluid">
        <div class="title">
            <div class="splash-subtitle">正在征选创意设计作品，即将开放报名！</div>
            <div class="splash-title" style="font-weight:400;margin-top:0.3rem">第三届清华未来设计师大赛</div>
            <div class="splash-subtitle" style="font-weight:400;">LogoUp 3D 为官方指定设计平台</div>
        </div>     
      </div>
    </div>
    <div class='container-fluid content'>
      <div class='slide content-section work-list ml-auto mr-auto' style="text-align:center">
        <h3 style='border-left:none'>往届大赛回顾 和 优秀作业作品</h3>
        <div class="row no-gutters">
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/basket-ball.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/dna-ring.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/fish.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/house.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/miky.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/pan.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/pipe-bracket.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/pythagoras.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/spiro.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/T2 Best Student Work - Lee.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/T3 Best Student Work - Airplane.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/T3 Best Student Work - Battleplane.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/T3 Best Student Work - Glider.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/T4 Best Student Work - Bottle.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/T4 Best Student Work - Fruit Plate.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/T4 Best Student Work - Gourd.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/T4 Best Student Work - Uisge Beatha.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/T5 Best Student Work - Balloon 2.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/T5 Best Student Work - Balloon.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/T5 Best Student Work - Traffic Cone.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/T6 Best Student Work - Bitmap.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/T6 Best Student Work - Desktop.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/T6 Best Student Work - Fan.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/T6 Best Student Work - Geometry Ball.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/T6 Best Student Work - Honnouji.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/T6 Best Student Work - Piano.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/T6 Best Student Work - Tsinghua Gate.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/T6 Best Student Work - Yinyang.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/T7 Best Student Work - Chicken.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/T7 Best Student Work - Mario.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/T7 Best Student Work - Minion.png'></img>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <img style="width: 100%" src='static/works/T8 Best Student Work - Doraemon.png'></img>
          </div>
        </div>
      </div>    
      <div class='content-section'>
        <h3 style='text-align:center;border-left:none'>初赛截至日期：2017 年 6 月 30 日</h3>
        <div style='text-align:center;margin-top:1.5em;'>
          <a class='download' href='/static/competition-info.zip' target='_blank'>下载大赛章程和报名表</a>
        </div>
      </div>      
      <div class='slide'>
        为响应国家教育事业发展“十三五”规划（国务院关于印发国家教育事业发展“十三五”规划的通知国发〔2017〕4号）中关于
        推进大众创业万众创新、实施“中国制造2025”等方面的号召，
        激发青少年对三维设计、3D 打印技术的兴趣，
        培养青少年创新精神与能力，强化学生实践动手能力，全面推进素质教育，
        由清华大学软件学院主办（清华大学计算机辅助设计、图形学与可视化研究所、
        北京清软海芯科技有限公司承办）第二届清华 <b>未来设计师大赛</b>，
        通过三维软件创意设计让 3D 打印实现青少年创新创意和梦想。
        现面向全国征集优秀作品！
      </div>
      <div class='content-section'>
        <h3>大赛流程</h3>
        <div class='text'>
          <div class='formula'>
            <div class='item'>
              <h4>线上报名</h4>
              <span>2017 年 6 月 1 日起</span>
            </div>
            <div class='symbol'>&gt;</div>
            <div class='item'>
              <h4>预赛</h4>
              <span>截至：2017 年 6 月 30 日</span>
            </div>
            <div class='symbol'>&gt;</div>
            <div class='item'>
              <h4>决赛</h4>
              <span>2017 年 7 月 19 日上午</span>
            </div>
            <div class='symbol'>&gt;</div>
            <div class='item'>
              <h4>夏令营活动</h4>
              <span>2017 年 7 月 20 - 21 日</span>
            </div>
          </div>
        </div>
      </div>
      <div class='content-section'>
        <h3>大赛命题和要求</h3>
        <div class='text'>
          <p>竞赛以命题的形式，引导学生利用所学三维设计与 3D 打印技术知识，自主进行命题范 围内的任意设计与创造，基本知识涉及三维设计建模、建筑、计算机控制、3D 技术等。</p>
          <p>根据不同学段学生特点，大赛分为 3 个组别：低年龄段(6-11 岁)、中年龄段（12-15 岁） 和高年龄段（16-18 岁）。</p>
          <p>比赛为个人赛，每位选手需有 1 位指导教师</p>
          <p><b>命题：</b></p>
          <ol>
            <li>低年龄段（6-11 岁）命题：动物世界。设计一个独特的 动物形象，然后以照片的形式记录下来，连同设计方案（包括设计的动物形象是什么， 为什么要这样设计，以及设计的意义）一并以邮件形式发给我们。</li>
            <li>中年龄段（12-15 岁）和高年龄段（16-18 岁）命题：创意花瓶。 花瓶由瓶口、瓶颈、瓶身几部分组成，表面带有不同的花纹，装点着我们的日常生活。 假设你是花瓶的设计者，请发挥创意用 LogoUp 3D 设计出你心中的创意花瓶，连同 设计方案（包括为什么要这样设计，以及设计的意义）一并以邮件形式发给我们。</li>
          </ol>
          <p><b>作品递交方式</b>：所有参赛选手在 2017 年 6 月 30 前提交设计方案、效果图及加盖学校公章的报名表的电 子版发送至 <span style="word-wrap: break-word">cooperation@hesion3d.com</span>，邮件以“组别+学校+选手名称”命名，由清华 大学软件学院的评委教师对作品进行筛选，最终于 7 月 7 前公布并通知入围决赛的团队。</p>
        </div>
      </div>
      <div class='content-section'>
        <h3>评选和奖励</h3>
        <div class='text'>
          <p><b>评选方法</b></p>
          <ol>
            <li>根据规则进行评判，按年龄组别分设一二三等奖（1 名，3 名，5 名）。</li>
            <li>设优秀指导教师奖三名，颁发给教师个人。</li>
          </ol>
          <p><b>奖励标准</b></p>
          <ol>
            <li>大赛一二三等奖，授予证书和奖品。</li>
            <li>优秀教师奖：授予证书和奖金。</li>
          </ol>  
        </div>
      </div>
      <div class='content-section'>&nbsp;<br />&nbsp;<br /></div>
    </div>-->
  </div>
</template>

<script>
export default {
  name: "competition",
  data() {
    return {};
  },
  mounted: function() {
    var navDiv = document.getElementById("nav-1");
    var mt = navDiv.offsetTop;
    // console.log(mt)
    window.onscroll = function() {
      var t = document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(t)
      if (t > mt) {
        navDiv.style.position = "fixed";
        navDiv.style.top = "0";
      } else {
        navDiv.style.position = "relative";
      }
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table-top {
  font-size: 2.0vw;
  vertical-align: middle;
  border: 3px solid rgb(87, 120, 187);
  border-bottom: 0;
  background: rgb(235, 207, 12);
  border-top-left-radius: 1.5em;
  border-top-right-radius: 1.5em;
  -webkit-border-top-left-radius: 2em;
  color: rgb(207, 102, 57);
  text-align: center;
  font-weight: bold;
  vertical-align: middle;
}
.table-header {
 color:rgb(135,178,225);
  font-size: 1.2vw;
  text-align: center;
}



.comp-bg {
  background-image: url(/static/competition-bg-1.jpg);
}
.nav-1 {
  background-color: rgb(8, 27, 82);
  z-index: 2000;
}
.container-sm {
  padding: 0;
}
.navbar {
  padding: 0 1rem;
}
.nav-link {
  padding: 0rem 0rem;
}
.splash {
  background-color: #4d8cc9;
  background-image: url(/static/banner-competition.jpg);
  background-position: center;
  transition: background 1s;
}
.splash .ui-img {
  margin-left: -2rem;
  display: inline-block;
}
.splash .title {
  vertical-align: top;
  color: white;
  text-shadow: 2px 2px 3px #0078d7;
  font-weight: 100;
  text-align: center;
}
.work-list {
  max-width: 1040px;
}
#app a.download {
  padding: 0.5em 1em;
  display: inline-block;
  background: #0078d7;
  color: white;
  text-shadow: none;
  box-shadow: 1px 1px 3px 3px #ccc;
  border-radius: 16px;
  cursor: pointer;
  text-align: center;
  padding: 1em 2em;
  margin-left: 1em;
  font-size: 24px;
}
.download:hover {
  background: #0058a7;
}
.multi {
  text-align: center;
}
.multi .section {
  display: inline-block;
  width: 24%;
  text-align: center;
  vertical-align: middle;
}
.multi .section h3 {
  font-size: 24px;
  font-weight: 100;
}
.multi .section .text {
  margin-top: 1em;
  font-weight: 100;
}
.text {
  margin-left: 2rem;
}
.multi .bracket {
  color: #ddd;
  font-weight: 100;
  font-size: 6.5vw;
  vertical-align: middle;
}
.multi .times {
  display: inline-block;
  color: #ddd;
  font-size: 3vw;
  vertical-align: middle;
}
.slide {
  background: #f0f0f0;
  padding: 2em 3em;
  margin-top: 2em;
  margin-bottom: 2em;
  line-height: 32px;
  border: solid 1px #ddd;
  border-radius: 16px;
  font-size: 18px;
  font-weight: 100;
}
.slide b {
  color: #0078d7;
}
.content-section .text {
  color: #666;
  font-weight: 100;
  line-height: 1.7em;
}
.content-section ol {
  list-style: disc;
}
.content-section h3 {
  font-weight: 100;
  font-size: 1.8rem;
  border-left: solid 16px #0078d7;
  padding-left: 16px;
  margin-bottom: 1rem;
  margin-top: 1rem;
}
.content-section h3 div {
  font-size: 1.4rem;
  color: #666;
}
.formula {
  vertical-align: middle;
  text-align: center;
}
.formula .item {
  display: inline-block;
  border-radius: 8px;
  border: solid 1px #ccc;
  padding: 0.8rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  text-align: center;
  vertical-align: middle;
  background-color: #f84;
  color: white;
}
.formula .symbol {
  display: inline-block;
  vertical-align: middle;
  font-weight: 400;
}
table th {
  padding: 0.8em 1em;
  border-bottom: solid 1px #ccc;
  color: #f84;
  font-size: 18px;
  text-align: left;
}
table td {
  padding: 0.5em 1em;
  text-align: left;
  font-size: 16px;
}
h4 {
  font-size: 2vw;
  font-weight: 100;
}
.work-list img {
  background-color: #808080;
  width: 200px;
  border-radius: 1em;
  border: solid 1px #c0c0c0;
}
@media (min-width: 100px) {

.table-td {
  color: white;
  font-size: 2.6vw;
  text-align: center;
}
/* /积分规则 */
.jfgz{
 color: white;
  line-height:130%;
  font-size: 2.6vw;
  position: absolute;
}

.table-detail{
  text-align:center;
  margin-top:3rem;
  margin-bottom:3rem;
  color:white;
  font-size:2vw; 
  vertical-align:middle;
}

/* /大赛背景 */
.dsbj{
 color: white;
 line-height:150%;
  font-size: 2.8vw;
  position: absolute;
}
.csxs{
 color: white;
  letter-spacing:  0.2vw;
  font-size: 2vw;
  position: absolute;
}
/* /奖品激励 */
.jpjl{
 color: white;
  letter-spacing:  0.1vw;
   line-height:170%;
  font-size: 2.6vw;
  position: absolute;
}

/* 比赛细则 */
.bsxz{
 color: white;
  /* letter-spacing:  0.2vw; */
  font-size: 2.5vw;
  position: absolute;
}
/* 作品提交 */
.zptj{
 color: white;
  /* letter-spacing:  0.2vw; */
   line-height:160%;
  font-size: 2.6vw;
  position: absolute;
}
/* 作品要求 */
.zpyq{
 color: white;
  /* letter-spacing:  0.2vw; */
  font-size: 2.6vw;
  position: absolute;
}
/* 版权声明 */
.bqsm{
 color: white;
  /* letter-spacing:  0.3vw; */
  font-size: 2.3vw;
  position: absolute;
}

/* LogoUp试用说明 */
.sysm{
 color: white;
  line-height:150%;
  /* letter-spacing:  0.3vw; */
  font-size: 2.6vw;
  position: absolute;
}

.image-fontsize {
  color: white;
  /* letter-spacing:  0.2vw; */
  font-size: 2vw;
  position: absolute;
}


  .splash-title {
    font-size: 5vw;
  }
  .splash-subtitle {
    font-size: 3vw;
  }
  .splash .download {
    padding: 0.4rem 0.4rem;
    font-size: 0;
  }
  .multi .section {
    display: block;
  }
  .multi .bracket {
    display: none;
  }
  .multi .times {
    display: none;
  }
  .formula .item {
    font-size: 0.5vw;
  }
  .formula .symbol {
    font-size: 0.8vw;
  }
  .formula span {
    font-size: 0.5vw;
  }
  .work-list {
    padding-left: 3rem;
    padding-right: 3rem;
  }
}
@media (min-width: 576px) {
  .work-list {
    padding-left: 4rem;
    padding-right: 4rem;
  }
}
@media (min-width: 768px) {

/* /积分规则 */
.jfgz{
 color: white;
  line-height:130%;
  font-size: 1.6rem;
  position: absolute;
}


/* /大赛背景 */
.dsbj{
 color: white;
 line-height:150%;
  font-size: 1.8rem;
  position: absolute;
}

/* /奖品激励 */
.jpjl{
 color: white;
  letter-spacing:  0.2vw;
   line-height:170%;
  font-size: 1.6rem;
  position: absolute;
}

/* 比赛细则 */
.bsxz{
 color: white;
  /* letter-spacing:  0.2vw; */
  font-size: 1.8rem;
  position: absolute;
}
/* 作品提交 */
.zptj{
 color: white;
  /* letter-spacing:  0.2vw; */
   /* line-height:120%; */
  font-size: 1.2rem;
  position: absolute;
}
/* 作品要求 */
.zpyq{
 color: white;
  /* letter-spacing:  0.2vw; */
  font-size: 1.6rem;
  position: absolute;
}
/* 版权声明 */
.bqsm{
 color: white;
  /* letter-spacing:  0.3vw; */
  font-size: 1.5rem;
  position: absolute;
}

/* LogoUp试用说明 */
.sysm{
 color: white;
  line-height:150%;
    letter-spacing:  0.2vw;
  /* letter-spacing:  0.3vw; */
  font-size: 1.6rem;
  position: absolute;
}

.image-fontsize {
  color: white;
  /* letter-spacing:  0.2vw; */
  font-size: 1vw;
  position: absolute;
}


  .splash {
    height: 30rem;
  }
  .title {
    padding-bottom: 5rem;
  }
  .splash-title {
    font-size: 2.6rem;
  }
  .splash-subtitle {
    font-size: 1.7rem;
  }
  .splash .download {
    padding: 1rem 0.2rem;
    font-size: 0.5rem;
  }
  .multi .section {
    display: inline-block;
  }
  .multi .section .text {
    font-size: 1.4vw;
  }
  .multi .section img {
    width: 12vw;
    max-width: 128px;
  }
  .multi .bracket {
    display: inline-block;
  }
  .multi .times {
    display: inline-block;
  }
  .formula .item {
    font-size: 1.4vw;
  }
  .formula .symbol {
    font-size: 1.8vw;
  }
  .formula span {
    font-size: 1vw;
  }
  .work-list {
    padding-left: 5rem;
    padding-right: 5rem;
  }
}
@media (min-width: 992px) {

.table-td {
  color: white;
  font-size: 1.6rem;
  text-align: center;
}


.table-detail{
  text-align:center;
  margin-top:3rem;
  margin-bottom:3rem;
  color:white;
  font-size:1vw; 
  vertical-align:middle;
}

/* /积分规则 */
.jfgz{
 color: white;
  letter-spacing:  0.2vw;
  font-size: 1.8rem;
  position: absolute;
}


/* /大赛背景 */
.dsbj{
 color: white;
  letter-spacing:  0.2vw;
  font-size: 1.4rem;
  position: absolute;
}

/* /参赛学生 */
.csxs{
 color: white;
  letter-spacing:  0.2vw;
  font-size: 1.2vw;
  position: absolute;
}
/* /奖品激励 */
.jpjl{
 color: white;
  letter-spacing:  0.3vw;
    line-height:180%;
  font-size: 1.6rem;
  position: absolute;
}

/* 比赛细则 */
.bsxz{
 color: white;
  letter-spacing:  0.2vw;
  font-size: 2rem;
  position: absolute;
}
/* 作品提交 */
.zptj{
 color: white;
  line-height:170%;
  letter-spacing:  0.3vw;
  font-size: 1.8rem;
  position: absolute;
}
/* 作品要求 */
.zpyq{
 color: white;
  line-height:170%;
  letter-spacing:  0.3vw;
  font-size: 1.8rem;
  position: absolute;
}
/* 版权声明 */
.bqsm{
 color: white;
  letter-spacing:  0.3vw;
   line-height:160%;
  font-size: 1.6rem;
  position: absolute;
}

/* LogoUp试用说明 */
.sysm{
 color: white;
  line-height:130%;
  letter-spacing:  0.2vw;
  font-size:  1.8rem;;
  position: absolute;
}

.image-fontsize {
  color: white;
  /* letter-spacing:  0.2vw; */
  font-size: 1vw;
  position: absolute;
}

  .splash .download {
    font-size: 0.6rem;
  }
  .formula .item {
    font-size: 2.4vw;
  }
  .formula .symbol {
    font-size: 2.4vw;
  }
  .formula span {
    font-size: 1.6vw;
  }
  .work-list {
    padding-left: 6rem;
    padding-right: 6rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/competition.vue